import { useRoutes } from "react-router-dom";

//Import Routes
import Router from "./Router";

//Routing Render
const MainRoutes = () => {
  return useRoutes([Router]);
};

export default MainRoutes;
